import gsap from 'gsap';

export function blendEases(
  startEase: gsap.EaseString | gsap.EaseFunction,
  endEase: gsap.EaseString | gsap.EaseFunction,
  blender: gsap.EaseString | gsap.EaseFunction = gsap.parseEase('power4.inOut'),
): gsap.EaseFunction {
  const parsedStartEase = gsap.parseEase(startEase);
  const parsedEndEase = gsap.parseEase(endEase);
  const parsedBlender = gsap.parseEase(blender);
  return (value: number) => {
    const mul = parsedBlender(value);
    return parsedStartEase(value) * (1 - mul) + parsedEndEase(value) * mul;
  };
}
